import React from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import loadable from '@loadable/component'
import { Loader } from '../../../../common/components';

const ListTranslationPage = loadable(() => import('./ListTranslationPage'), {
    fallback: <Loader/>,
});
const AddTranslationPage = loadable(() => import('./AddTranslationPage'), {
    fallback: <Loader/>,
});
const EditTranslationPage = loadable(() => import('./EditTranslationPage'), {
    fallback: <Loader/>,
});
const TranslationRoutes = ({ t, alert }) => {
  return (
    <Routes>
      <Route index exact path="/list" element={<ListTranslationPage t={t} alert={alert} />} />
      <Route exact path="/add" element={<AddTranslationPage t={t} alert={alert} />} />
      <Route exact path="/edit/:translation_id" element={<EditTranslationPage t={t} alert={alert} />} />
      <Route path="*" element={<Navigate replace to="/404" />} />
    </Routes>
  );
};
TranslationRoutes.propTypes = {
  t: PropTypes.func
};
export default TranslationRoutes;
